import { render, staticRenderFns } from "./BusinessTransactionForm.vue?vue&type=template&id=8aba8042&"
import script from "./BusinessTransactionForm.vue?vue&type=script&lang=js&"
export * from "./BusinessTransactionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports